import Swiper from "swiper";
import { Pagination, Navigation } from "swiper/modules";


const featuredWorkCarousel = document.querySelectorAll('.js-featured-work-carousel');

 for (const highlightSlider of featuredWorkCarousel) {
    const swiperWrapper    = highlightSlider;
    const sliderPagination = highlightSlider.querySelector('.swiper-pagination');
    //const slideWrapper     = highlightSlider.querySelector('.swiper-wrapper');

    new Swiper(swiperWrapper, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: sliderPagination,
        clickable: true
      }
    });
}
